export default class MrtNotifications {
    constructor() {
        this.successes = [];
        this.errors = [];
    }

    reset() {
        this.successes = [];
        this.errors = [];
    }

    success(message) {
        this.reset();
        this.successes.push(message);
    }

    addSuccess(message) {
        this.successes.push(message);
    }

    error(message) {
        this.reset();
        this.errors.push(message);
    }

    addError(message) {
        this.errors.push(message);
    }
}
